var moduleMap = {
	"./index.js": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js-node_modules_url_url_js"), __webpack_require__.e("vendors-node_modules_classnames_dedupe_js-node_modules_classnames_index_js-node_modules_prop--48d8ea"), __webpack_require__.e("vendors-node_modules_enpowered_jsonrpc-client_dist_es6_index_js-node_modules_amazon-cognito-i-275c41"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("webpack_sharing_consume_default_react-query_react-query"), __webpack_require__.e("src_bootstrap_js")]).then(() => (() => ((__webpack_require__(5182)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});